import { Badge } from '../primitives/badge';
import type { Tone } from '../lib/tone';

export interface StatusOption {
  label: string;
  tone: Tone;
}

interface StatusBadgeProps<TStatus extends string> {
  status: TStatus;
  /** One map per record type, e.g. jobStatuses = { open: { label: 'Open', tone: 'info' }, ... } */
  statuses: Record<TStatus, StatusOption>;
  className?: string;
}

/** Shows a status with the same colour everywhere it appears. */
export function StatusBadge<TStatus extends string>({
  status,
  statuses,
  className,
}: StatusBadgeProps<TStatus>) {
  const option = statuses[status] ?? { label: status, tone: 'neutral' as const };
  return (
    <Badge tone={option.tone} className={className}>
      {option.label}
    </Badge>
  );
}
